import { useAuth } from "@/context/AuthContext";
import { AdminLogin } from "@/components/admin/AdminLogin";
import { AdminDashboard } from "@/components/admin/AdminDashboard";
import { Loader2 } from "lucide-react";

export default function Admin() {
  const { user, checking } = useAuth();
  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="admin-loading">
        <Loader2 className="animate-spin text-blue-600" size={32} />
      </div>
    );
  }
  return user ? <AdminDashboard /> : <AdminLogin />;
}
